import { render, staticRenderFns } from "./LoyaltyCardForm.vue?vue&type=template&id=21da0d88"
import script from "./LoyaltyCardForm.vue?vue&type=script&lang=js"
export * from "./LoyaltyCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports